module.exports = __webpack_public_path__ + "img/5.2a55a60f.webp";